export interface OnlyNumericValidationErrorProps {
  regex: RegExp;
}
export class OnlyNumericValidationError
  implements OnlyNumericValidationErrorProps
{
  constructor(public regex: RegExp) {}
}
